// extracted by mini-css-extract-plugin
module.exports = {"container":"EmailVerification_container__3MhzN"};